/** Fixed palette of bookmark / note colors, independent of theme palette. */
export const bookmarkColors = [
	'#FF6B6B', // coral red
	'#FFB347', // warm orange
	'#FFD93D', // sunflower
	'#6BCB77', // fresh green
	'#4D96FF', // cornflower blue
	'#9D4EDD', // violet
	'#FF6FAE', // pink
] as const;

export type BookmarkColor = (typeof bookmarkColors)[number];

/** Note color cycle: palette colors, then no color, then wraps. */
const noteColorCycle: readonly (BookmarkColor | null)[] = [...bookmarkColors, null];

/** Advance to the next note color (includes no-color). Unknown colors start at the first swatch. */
export function nextBookmarkColor(current: string | null | undefined): string | null {
	const currentIdx =
		current == null ? -1 : bookmarkColors.indexOf(current as BookmarkColor);
	const nextIdx = (currentIdx + 1) % noteColorCycle.length;
	return noteColorCycle[nextIdx];
}
